import { gql } from '@apollo/client';

export const SEARCH_HOTEL_BY_NAME = gql`
  query SearchHotelByName($hotelName: String!) {
    hotels(where: { name_contains: $hotelName }) {
      id
      name
      logo {
        id
        url
        formats
      }
    }
  }
`;
